export default {
    version: "0.5"
};
